export function noRoundPercents(
  value: any,
  decimals: string | number = 0
): any {
  if (isNaN(value) || (!value && value !== 0)) {
    return value;
  }

  let decimalValue = Math.round(
    typeof decimals === 'string' ? parseInt(<string>decimals, 10) : decimals
  );
  if (isNaN(decimalValue) || decimalValue < 0 || decimalValue > 20) {
    decimalValue = 0;
  }

  // normal cases
  if (value <= 0 || value >= 100 || (value >= 1 && value <= 99)) {
    return (+value).toFixed(decimalValue) + '%';
  }

  // edge cases
  if (decimalValue === 0) {
    return value < 1 ? '<1%' : '99%';
  }

  // edge cases + decimals
  const pow10 = Math.pow(10, decimalValue);
  value *= pow10;
  value = Math.round(value < 1 ? Math.ceil(value) : Math.floor(value));
  value /= pow10;

  return `${value}%`;
}
